import { render, staticRenderFns } from "./PickList.vue?vue&type=template&id=6b371ab6"
import script from "./PickList.vue?vue&type=script&lang=js"
export * from "./PickList.vue?vue&type=script&lang=js"
import style0 from "./PickList.vue?vue&type=style&index=0&id=6b371ab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports